import React from "react";
import { Checkbox, CheckboxProps } from "./Checkbox";

interface PolicyCheckboxProps extends CheckboxProps {
    policyUrl: string;
}

export const PolicyCheckbox = (props: PolicyCheckboxProps) => {
    const {
        label,
        policyUrl
    } = props;

    const linkedLabel = !!policyUrl.length && label?.indexOf("#") !== -1
        ? label?.replace(/#(.+?)#/i, `<a href="${policyUrl}" target="_blank" rel="noreferrer">$1</a>`)
        : label;

    return <Checkbox {...props} label={linkedLabel} />;
};
